import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ArchivQuerySorterConfig } from 'fa-kt.types';
import { ArchivService } from '../service';

@Component({
  selector: 'fa-kt-archiv-sorter',
  templateUrl: './archiv-sorter.component.html',
  styleUrls: ['./archiv-sorter.component.css'],
})
export class ArchivSorterComponent {
  public ArchivSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public archiv: ArchivService,
  ) {
    this.ArchivSorterConfig = ArchivQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
